/*--------------------------------------------------------------------------*
 * ポップアップウィンドウ
 *
 * jquery.openwin.js
 * http://shanabrian.com/web/jquery/window01.php
 *
 * 下記の様にhtml側のrel要素で個別にオプション指定も可。
 * <a href='' data-popup rel='scrollbars=yes,target=_self,blur=true'>hoge</a>
 *--------------------------------------------------------------------------*/

// ウィンドウがロードされたら実行
window.onload = function () {
  // ポップアップウィンドウの設定
  $('[data-popup]').openwin({
    option: {
      width: 1024,
      height: 900,
      top: false,
      left: false,
      menubar: 'no',
      toolbar: 'no',
      location: 'no',
      status: 'no',
      resizable: 'yes',
      scrollbars: 'yes',
      directories: 'no',
      titlebar: 'yes',
      fullscreen: 'no',
    },
  });
};

(function ($) {
  $.fn.openwin = function (settings) {
    settings = jQuery.extend(
      {
        option: {
          width: false,
          height: false,
          top: false,
          left: false,
          menubar: 'no',
          toolbar: 'no',
          location: 'no',
          status: 'no',
          resizable: 'no',
          scrollbars: 'no',
          directories: 'no',
          titlebar: 'yes',
          fullscreen: 'no',
        },
        target: '_blank',
        focus: true,
      },
      settings
    );

    this.click(function () {
      var options = [];
      if ($(this).attr('rel')) {
        var rel = $(this).attr('rel').split(',');
        var reloption = {};
        for (var i in rel) {
          var a = rel[i].split('=');
          reloption[a[0]] = a[1];
        }
      }
      for (var k in settings.option) {
        var v = settings.option[k];
        if (reloption) {
          if (reloption[k]) {
            v = reloption[k];
          }
        }
        if (v != false) {
          options.push(k + '=' + v);
        }
      }
      var target = settings.target;
      if (reloption) {
        if (reloption['target']) {
          target = reloption['target'];
        }
      }
      var win = window.open($(this).attr('href'), target, options.join(','));
      return false;
    });
  };
})(jQuery);
